<!--tab-->
<template>
  <div class="data-card-tab">
    <template v-for="(item,index) in tabList">
      <div :id="name+index" :key="index" :class="['data-card-tab-item',{'data-card-tab-active':curIndex==index}]"
        @click="onSwitchTab(index,item)">{{item.name}}</div>
      <div class="data-card-tab-space" id="tab-space" :key="index+'space'">
         <div class="notice-contain" v-if="item.value=='complaint'">
            <div class="notice-num" v-if="noticeNumComplain > 0 && noticeNumComplain < 100"><i>{{noticeNumComplain}}</i></div>
             <div class="notice-num" v-if="noticeNumComplain > 99"><i>99+</i></div>
          </div>
         <div class="notice-contain" v-if="item.value=='trave'">
            <div class="notice-num" v-if="noticeNumTravel > 0 && noticeNumTravel < 100"><i>{{noticeNumTravel}}</i></div>
             <div class="notice-num" v-if="noticeNumTravel > 99"><i>99+</i></div>
          </div>
          <div class="notice-contain" v-if="item.value=='inner'">
            <div class="notice-num" v-if="noticeNumIntegrity > 0 && noticeNumIntegrity < 100"><i>{{noticeNumIntegrity}}</i></div>
             <div class="notice-num" v-if="noticeNumIntegrity > 99"><i>99+</i></div>
          </div>
          <div class="notice-contain" v-if="item.value=='refund'">
            <div class="notice-num" v-if="noticeNumRefund > 0 && noticeNumRefund < 100"><i>{{noticeNumRefund}}</i></div>
             <div class="notice-num" v-if="noticeNumRefund > 99"><i>99+</i></div>
          </div>
          <div class="notice-contain" v-if="item.value=='guide'">
            <div class="notice-num" v-if="noticeNumGuide > 0 && noticeNumGuide < 100"><i>{{noticeNumGuide}}</i></div>
             <div class="notice-num" v-if="noticeNumGuide > 99"><i>99+</i></div>
          </div>
          <div class="notice-contain" v-if="item.value=='attract'">
            <div class="notice-num" v-if="noticeNumAttract > 0 && noticeNumAttract < 100"><i>{{noticeNumAttract}}</i></div>
             <div class="notice-num" v-if="noticeNumAttract > 99"><i>99+</i></div>
          </div>
          <div class="notice-contain" v-if="item.value=='touristPrivacy'">
            <div class="notice-num" v-if="noticeNumTouristPrivacy > 0 && noticeNumTouristPrivacy < 100"><i>{{noticeNumTouristPrivacy}}</i></div>
             <div class="notice-num" v-if="noticeNumTouristPrivacy > 99"><i>99+</i></div>
          </div>
      </div>
    </template>

    <div ref="line" class="data-card-tab-line"
      :style="'width:'+width+'px;transform:translateX('+left+'px);transition-duration: 0.3s;height:2px;'"></div>
  </div>
</template>
<script>
    export default {
        components: {},
        props: {
            // 数据
            tabList: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            name: {
                type: String,
                default: ''
            }
        },
        data () {
            return {
                curIndex: 0,
                width: 0,
                left: 0
            };
        },
        computed: {
            noticeNumTravel () {
                return this.$store.state.notice.noticeNumTravel
            },
            noticeNumComplain () {
                return this.$store.state.notice.noticeNumComplain
            },
            noticeNumIntegrity () {
                return this.$store.state.notice.noticeNumIntegrity
            },
            noticeNumRefund () {
                return this.$store.state.notice.noticeNumRefund
            },
            noticeNumGuide () {
                return this.$store.state.notice.noticeNumGuide
            },
            noticeNumAttract() {
              return this.$store.state.notice.noticeNumAttract;
            },
            noticeNumTouristPrivacy() {
              return this.$store.state.notice.noticeNumTouristPrivacy;
            }
        },
        methods: {
            onSwitchTab (idx, item) {
                this.switchTab(idx);
                this.$emit('onSwitch', item);
            },
            switchTab (index) {
                this.curIndex = index;
                let length = 0;
                for (let i = 0; i < this.tabList.length; i++) {
                    let tabDiv = document.querySelector('#' + this.name + i);
                    if (i < index) {
                        length +=
                            tabDiv.offsetWidth +
                            document.querySelector('#tab-space').offsetWidth
                    } else if (i === index) {
                        this.width = tabDiv.offsetWidth;
                    }
                }
                this.left = length;
            }
        },
        mounted () {
            console.log(this.tabList)
            this.switchTab(0);
        }
    };
</script>

<style scoped lang="less">
  .data-card-tab {
    position: relative;
    overflow-x: scroll;
    white-space: nowrap;
    // display: flex;
    // align-items: center;
    /*不换行*/
    height: 50px;

    &-item {
      display: inline-block;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      color: rgba(51, 51, 51, 1);
      line-height: 50px;
      text-align: left;

    }

    &-space {
      display: inline-block;
      width: 30px;
      .notice-contain{
          position: relative;
          .items-img {
            width: 40px;
            height: 40px;
            margin-bottom: 8px;
          }
          .notice-num{
              background: #ff4d4d;
              position: absolute;
              top: -20px;
              left: 0px;
              z-index: 10;
              border: 1px solid #ffffff;
              width:19px;
              height:19px;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              i{
                  font-size:12px;
                  color:#fff;
                  transform: scale(0.8);
              }

            // background: #ff4d4d;
            // border-radius: 8px;
            // height: 15px;
            // padding: 0 4px;
            // font-size:8px;
            // line-height:15px;
            // font-family:PingFangSC-Medium,PingFang SC;
            // font-weight:500;
            // color:rgba(255,255,255,1);
            // position: absolute;
            // top: -20px;
            // left: 0px;
            // z-index: 10;
            // border: 1px solid #ffffff;
            // min-width: 15px;
          }
        }
    }

    &-active {
      color: rgba(54, 179, 116, 1);
      font-weight: 700;
    }

    &-line {
      position: absolute;
      bottom: 12px;
      left: 0;
      width: 56px;
      height: 2px;
      background: rgba(54, 179, 116, 1);
    }
  }

  .data-card-tab::-webkit-scrollbar {
    display: none;
  }
</style>
